import React from "react"
import {Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { StaticQuery, graphql } from "gatsby"
import { Remarkable } from 'remarkable';
var md = new Remarkable();

const Mentor_details = () => (

  
    <StaticQuery query={mentor_details_query} render={data=>{     
      console.log(data)
        return (  
        <div>
            <Layout>
                <SEO title="Mentors" />            

        <section id="result" class="section-1 offers">
            <div class="container">
           
           
            <div class="row items">

            {data.allMarkdownRemark.edges.map((tag,index) => ( 
                <div class="col-12 col-md-4 item">
                    
                    <div class="card" style={{padding:"15px"}}>
                        <div class="col-12"  >
                            <h3 style={{margin: "0.75rem 0", fontSize: "1.5rem"}}>{tag.node.frontmatter.name}</h3>
                            <h4 style={{margin: "0.75rem 0",fontSize: "1.0rem"}}>{tag.node.frontmatter.area_of_specialization}</h4>
                            {/* <div dangerouslySetInnerHTML={{__html:md.render(tag.node.frontmatter.area_of_specialization)}}></div> */}
                            
                            <div style={{marginBottom:"12px"}}>{tag.node.frontmatter.basic_intro}</div>
                            <div style={{fontSize: "12px"}}>{tag.node.frontmatter.email}</div>
                            <div style={{fontSize: "12px"}}>{tag.node.frontmatter.linkedIn_profile}</div>
                         
                        </div>

                    </div>

                </div>

            ))}

                
             
            </div>
            
            </div>
        </section>


       
        </Layout>
            
            
            
            </div>
      )
    }}/>
    )
  

    const mentor_details_query = graphql`
    query mentor_details_query{
      allMarkdownRemark(filter: {fileAbsolutePath: {regex: "posts/resources/mentors_details/"}} 
      ) {
        edges {
          node {
            id
            frontmatter {
                name
                email
                area_of_specialization
                basic_intro
                linkedIn_profile
              
            }
           
          }
        }
      }
    }
    
     `
  
export default Mentor_details